import { Navigate, Outlet, useLocation } from "react-router";

import { SplashScreen } from "../../components/SplashScreen";
import { useSession } from "./useSession";

export function RequireAuth() {
  const { status } = useSession();
  const location = useLocation();

  // Splash, NOT a redirect: the bootstrap refresh is in flight and redirecting
  // would flash the sign-in screen on every reload of an authenticated session.
  if (status === "bootstrapping") return <SplashScreen />;

  if (status === "anonymous") {
    return <Navigate to="/signin" replace state={{ from: location }} />;
  }

  return <Outlet />;
}
